import React from "react";
import { LuInstagram, LuFacebook } from "react-icons/lu";
// import coffe from "Assets//aboudanLogo.png";
import "./style.css";

export const Footer = () => {
  return (
    <div className="flex_c footer_container">
      <div className="flex_r footer_sub_container">
        <div className="flex_c gap-20 footer_about">
          <div className="flex_r gap-20 footer_title">
            {/* <img
              src={coffe}
              alt={"brand logo"}
              className="background_footer_logo"
            /> */}
            <h1>Marketique</h1>
          </div>
          <p>
            We are a leading seller of innovative and eco-friendly technology
            solutions, specializing in portable solar-powered chargers for
            mobile devices. Our products are designed for outdoor enthusiasts,
            travelers, and anyone seeking sustainable energy solutions. With a
            focus on quality, durability, and performance, we provide customers
            with reliable charging solutions that keep them connected wherever
            they go. Join us in our mission to empower individuals with
            convenient, renewable energy options for a brighter, more
            sustainable future.
          </p>
        </div>

        <div className="flex_c gap-20 footer_info">
          <div className="footer_title">
            <h1> More Info</h1>
          </div>
          <div className="flex_c footer_list">
            <p>Improving your Sales</p>
            <p>Developing your website</p>
            <p>Design your website and products</p>
          </div>
        </div>

        <div className="flex_c gap-20 footer_contact">
          <div className="footer_title">
            <h1>Contact Us</h1>
          </div>
          <ul className="flex_c gap-10 footer_list">
            <li>+961 71 728 733</li>
            <li>Tripoli Lebanon</li>
            <li>El Mina Tripoli</li>
            <div className="flex_r gap-10">
              <a
                href="https://www.facebook.com/marketique.online/"
                target="_blank"
              >
                <LuFacebook className="social_icon" />
              </a>
              <a
                href="https://www.instagram.com/marketique.online/"
                target="_blank"
              >
                <LuInstagram className="social_icon" />
              </a>
            </div>
          </ul>
        </div>
      </div>

      <div className="flex_r footer_copy_right">
        <p>Copyright ©Moe Matar All rights reserved '2024'.</p>
      </div>
    </div>
  );
};
